import Vue from 'vue'

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  const arr = value.split(' ')
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('truncate', function (value, limit) {
  return value.substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
  return value + tail
})

Vue.filter('time', function (value, is24HrFormat = false) {
  if (value) {
    const date = new Date(Date.parse(value))
    let hours = date.getHours()
    const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
    if (!is24HrFormat) {
      const time = hours > 12 ? 'AM' : 'PM'
      hours = hours % 12 || 12
      return `${hours}:${min} ${time}`
    }
    return `${hours}:${min}`
  }
})

Vue.filter('date', function (value, fullDate = false) {
  value = String(value)
  const date = value.slice(8, 10).trim()
  const month = value.slice(4, 7).trim()
  const year = value.slice(11, 15)

  if (!fullDate) return `${date} ${month}`
  else return `${date} ${month} ${year}`
})

Vue.filter('month', function (val, showYear = true) {
  val = String(val)

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./
  if (!showYear) {
    return regx.exec(val)[1]
  } else {
    return `${regx.exec(val)[1]} ${regx.exec(val)[2]}`
  }

})

Vue.filter('csv', function (value) {
  return value.join(', ')
})

Vue.filter('filter_tags', function (value) {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
})

Vue.filter('k_formatter', function (num) {
  return num > 999 ? `${(num / 1000).toFixed(1)}k` : num
})

Vue.filter('slice', function (value) {
  return value.filter((i, index) => (index < 7))
})

Vue.filter('orderCount', function (objects, keyItem, status1, status2, status3, status4) {
  return objects.filter(function(item) {
    let a,b,c,d;
    if(status1) a = item[keyItem] == status1
    if(status2) b = item[keyItem] == status2
    if(status3) c = item[keyItem] == status3
    if(status4) d = item[keyItem] == status4
    return a || b || c || d;
  })
});

Vue.filter('ordersByDay', function (value) {  
  let todayDate = new Date();
  let getDaysArray = function(s,e) { 
    let a=[] 
      for(let d=new Date(s);d<=e;d.setDate(d.getDate()+1)){ 
        let dt = new Date( Number(d) );
        let dd = dt.getDate();
        let mm = dt.getMonth() + 1; 
        let yyyy = dt.getFullYear();
        if (dd < 10) { dd = '0' + dd; } 
        if (mm < 10) { mm = '0' + mm; } 
        a.push(dd + '-' + mm + '-' + yyyy)
      }
    return a;
  }

  let thisMonthFirstDay = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
  let lastMonthFirstDay = new Date(todayDate.getFullYear(), todayDate.getMonth()-1, 1);
  let lastMonthLastDay = new Date(todayDate.getFullYear(), todayDate.getMonth(), 0);

  let thisMonthDaysArray = getDaysArray(thisMonthFirstDay, todayDate);
  let lastMonthDaysArray = getDaysArray(lastMonthFirstDay, lastMonthLastDay);

  let thisMonthData = [], lastMonthData = [], thisMonth = 0, lastMonth = 0;

  lastMonthDaysArray.forEach((date) => {
    if( date in value ){
      lastMonthData.push( parseInt(value[date]) )
      lastMonth += value[date]
    } else {
      lastMonthData.push(0)
    }
  })

  thisMonthDaysArray.forEach((date) => {
    if( date in value ){
      thisMonthData.push( parseInt(value[date]) )
      thisMonth += value[date]
    } else {
      thisMonthData.push('')
    }
  })

  thisMonth = thisMonth == 0 ? thisMonth : parseInt(thisMonth)
  lastMonth = lastMonth == 0 ? lastMonth : parseInt(lastMonth)

  return { thisMonthData, lastMonthData, thisMonth, lastMonth }
})

